import classNames from 'classnames';

import AllCornersBorderRadius from '../types/UI/AllCornersBorderRadius';

import styles from './borderRadiusAsClasses.module.css';

const tl: Array<AllCornersBorderRadius> = ['all', 'top', 'left', 'topLeft'];
const tr: Array<AllCornersBorderRadius> = ['all', 'top', 'right', 'topRight'];
const bl: Array<AllCornersBorderRadius> = [
    'all',
    'bottom',
    'left',
    'bottomLeft',
];
const br: Array<AllCornersBorderRadius> = [
    'all',
    'bottom',
    'right',
    'bottomRight',
];

const borderRadiusAsClasses = (
    borderRadius: AllCornersBorderRadius,
    options?: {
        before?: boolean;
        after?: boolean;
        size?: 'regular' | 'large';
        transition?: boolean;
    }
): string => {
    const tlEnabled = tl.includes(borderRadius);
    const trEnabled = tr.includes(borderRadius);
    const blEnabled = bl.includes(borderRadius);
    const brEnabled = br.includes(borderRadius);

    return classNames({
        [styles.topLeft]: tlEnabled,
        [styles.topRight]: trEnabled,
        [styles.bottomLeft]: blEnabled,
        [styles.bottomRight]: brEnabled,

        [styles.topLeftBefore]: options?.before && tlEnabled,
        [styles.topRightBefore]: options?.before && trEnabled,
        [styles.bottomLeftBefore]: options?.before && blEnabled,
        [styles.bottomRightBefore]: options?.before && brEnabled,

        [styles.topLeftAfter]: options?.after && tlEnabled,
        [styles.topRightAfter]: options?.after && trEnabled,
        [styles.bottomLeftAfter]: options?.after && blEnabled,
        [styles.bottomRightAfter]: options?.after && brEnabled,

        [styles.sizeLarge]: options?.size === 'large',
        [styles.transition]: options?.transition,
    });
};

export default borderRadiusAsClasses;
